import { useEffect, useState } from 'react'

const formatTime = (time: number): string => {
  const hours = Math.floor(time / 3600)
  const minutes = Math.floor((time % 3600) / 60)
  const seconds = time % 60

  if (hours > 0) {
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  }
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

export const useCountdown = (timestamp: number) => {
  const [timeLeft, setTimeLeft] = useState<number>(0)
  const [isFinished, setIsFinished] = useState<boolean>(false)

  useEffect(() => {
    const updateTimeLeft = () => {
      const now = Date.now()
      const remainingTime = Math.max(0, Math.floor((timestamp - now) / 1000))
      setTimeLeft(remainingTime)
      setIsFinished(remainingTime === 0)
    }

    updateTimeLeft()
    const interval = setInterval(updateTimeLeft, 1000)

    return () => clearInterval(interval)
  }, [timestamp])

  return { time: formatTime(timeLeft), isFinished }
}
